import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SupportChat.vue?vue&type=script&setup=true&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SupportChat.vue?vue&type=script&setup=true&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/SupportChat.vue?vue&type=script&setup=true&lang=js
// module id = 572
// module chunks = 31